import { render } from "./StarTipDialog.vue?vue&type=template&id=aea8e426&scoped=true&ts=true"
import script from "./StarTipDialog.vue?vue&type=script&lang=ts"
export * from "./StarTipDialog.vue?vue&type=script&lang=ts"

import "./StarTipDialog.vue?vue&type=style&index=0&id=aea8e426&scoped=true&lang=css"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aea8e426"]])

export default __exports__